.panel {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-4);
  padding: var(--tuna-spacing-4);
  border: 1px solid var(--tuna-border-default);
  border-radius: var(--tuna-shape-borderRadius);
  background-color: var(--tuna-surface-default);
  align-items: center;
  text-align: center;
}

.scoreLine {
  font-size: var(--tuna-typography-h3-fontSize);
  margin: 0;
}

.actions {
  display: flex;
  gap: var(--tuna-spacing-2);
}
